import {BrowserModule} from '@angular/platform-browser';
import {DoBootstrap, NgModule, NgZone} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {APP_BASE_HREF} from '@angular/common';
import {PathInterceptor} from './services/path.interceptor';
import {trailingSlash} from '../environments/pathLocationStrategy';
import {AntragModule} from './antrag/antrag.module';
import {RouterModule} from '@angular/router';

@NgModule({ declarations: [], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        RouterModule.forRoot([]),
        AntragModule], providers: [
        globalThis.ngZone ? { provide: NgZone, useValue: globalThis.ngZone } : [],
        { provide: APP_BASE_HREF, useValue: '/' },
        { provide: HTTP_INTERCEPTORS, useClass: PathInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AntragsannahmeAppModule implements DoBootstrap {
  constructor(private antragModule: AntragModule) {
  }

  public ngDoBootstrap() {
    this.antragModule.addCustomElements();
  }
}

trailingSlash();
